export interface Movie {
  id: number;
  title: string;
  poster: string;
  year: number;
  rating: number;
  genre: string;
  region: string;
  duration: string;
  director: string;
  cast: string;
  tags: string[];
  blurb: string;
}

export const allMovies: Movie[] = [
  {
    id: 1,
    title: '暗夜追猎',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20action%20thriller%20movie%20poster%2C%20lone%20figure%20in%20rain-soaked%20alley%20at%20night%2C%20dramatic%20rim%20light%2C%20deep%20shadows%2C%20dark%20moody%20background%20with%20amber%20highlights%2C%20film%20grain%20texture%2C%20atmospheric%20fog&width=400&height=600&seq=sm-m1&orientation=portrait',
    year: 2025,
    rating: 8.6,
    genre: '动作',
    region: '中国大陆',
    duration: '128分钟',
    director: '陈默',
    cast: '林骁、苏芷、周衍',
    tags: ['硬核动作', '追凶', '雨夜'],
    blurb: '一场持续十二小时的雨夜追捕，让退役特勤与神秘嫌犯在城市的阴影里不断交锋，每一次擦肩都改写结局。',
  },
  {
    id: 2,
    title: '铁血征途',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20war%20epic%20movie%20poster%2C%20soldier%20silhouette%20against%20burning%20battlefield%20horizon%2C%20dramatic%20orange%20firelight%2C%20dark%20smoky%20background%2C%20gritty%20film%20grain%20texture%2C%20strong%20contrast%20composition&width=400&height=600&seq=sm-m2&orientation=portrait',
    year: 2024,
    rating: 8.2,
    genre: '动作',
    region: '中国大陆',
    duration: '141分钟',
    director: '韩铮',
    cast: '赵凛、白岚、徐霍',
    tags: ['战争', '群像', '史诗'],
    blurb: '一支被历史遗忘的运输队在雪原上护送最后一批物资，用血肉之躯撑起整条战线的呼吸。',
  },
  {
    id: 3,
    title: '都市狂飙',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20street%20racing%20movie%20poster%2C%20sports%20car%20speeding%20through%20rainy%20city%20street%20at%20night%2C%20motion%20blur%20light%20trails%2C%20dark%20urban%20background%20with%20teal%20and%20amber%20reflections%2C%20high%20contrast&width=400&height=600&seq=sm-m3&orientation=portrait',
    year: 2025,
    rating: 7.8,
    genre: '动作',
    region: '中国香港',
    duration: '118分钟',
    director: '梁奕',
    cast: '关屿、何晴、麦朗',
    tags: ['飙车', '兄弟情', '夜戏'],
    blurb: '地下赛车手为救回被挟持的弟弟，被迫参与一场横跨全城的极速赌局，油门踩到底的从来不只是速度。',
  },
  {
    id: 4,
    title: '星际回响',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20science%20fiction%20movie%20poster%2C%20astronaut%20floating%20before%20a%20glowing%20ringed%20planet%2C%20deep%20space%20dark%20background%20with%20teal%20nebula%20and%20warm%20starlight%2C%20epic%20scale%2C%20film%20grain&width=400&height=600&seq=sm-m4&orientation=portrait',
    year: 2025,
    rating: 8.9,
    genre: '科幻',
    region: '中国大陆',
    duration: '146分钟',
    director: '沈遨',
    cast: '季泽、许清欢、孟川',
    tags: ['硬科幻', '太空', '人性'],
    blurb: '当深空探测器传回一段无法破译的规律低语，一名孤独的领航员发现，答案或许就藏在出发那年的一张旧照片里。',
  },
  {
    id: 5,
    title: '量子迷航',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20thriller%20movie%20poster%2C%20futuristic%20spacecraft%20drifting%20near%20a%20black%20hole%2C%20dark%20cosmic%20background%20with%20violet%20and%20amber%20glow%2C%20dramatic%20lens%20flare%2C%20epic%20composition&width=400&height=600&seq=sm-m5&orientation=portrait',
    year: 2024,
    rating: 8.1,
    genre: '科幻',
    region: '中国大陆',
    duration: '133分钟',
    director: '沈遨',
    cast: '季泽、罗映、唐宁',
    tags: ['时空', '悬疑', '烧脑'],
    blurb: '一次失败的空间跃迁让飞船困在循环的七十二小时里，船员们必须找出那个从未登上飞船的第七个人。',
  },
  {
    id: 6,
    title: '机械黎明',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20cyberpunk%20movie%20poster%2C%20humanoid%20robot%20head%20with%20glowing%20amber%20eyes%2C%20dark%20industrial%20background%20with%20scattered%20sparks%2C%20moody%20lighting%2C%20detailed%20metallic%20texture%2C%20film%20grain&width=400&height=600&seq=sm-m6&orientation=portrait',
    year: 2025,
    rating: 7.9,
    genre: '科幻',
    region: '中国大陆',
    duration: '124分钟',
    director: '柯远',
    cast: '裴野、宁静殊、程亦',
    tags: ['赛博朋克', '人工智能', '反乌托邦'],
    blurb: '城市在清晨六点准时断电，只有机器人记得昨天发生的事，而人类开始怀疑自己是否也是被唤醒的那一批。',
  },
  {
    id: 7,
    title: '雾中真相',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20mystery%20movie%20poster%2C%20detective%20walking%20through%20thick%20fog%20on%20empty%20street%2C%20lone%20streetlamp%20glow%2C%20dark%20desaturated%20background%20with%20cool%20tones%2C%20suspenseful%20atmosphere%2C%20film%20grain&width=400&height=600&seq=sm-m7&orientation=portrait',
    year: 2024,
    rating: 8.4,
    genre: '悬疑',
    region: '中国大陆',
    duration: '112分钟',
    director: '娄未',
    cast: '严贺、苏芷、边然',
    tags: ['推理', '小镇', '反转'],
    blurb: '一场大雾封锁了整座小镇，也封锁了唯一的出口，而每个人都坚称案发时自己正站在雾里。',
  },
  {
    id: 8,
    title: '十三号公寓',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20horror%20mystery%20movie%20poster%2C%20dim%20apartment%20corridor%20with%20flickering%20light%2C%20single%20lit%20doorway%20at%20end%2C%20dark%20shadows%2C%20eerie%20green%20tone%2C%20unsettling%20atmosphere%2C%20film%20grain&width=400&height=600&seq=sm-m8&orientation=portrait',
    year: 2025,
    rating: 7.6,
    genre: '悬疑',
    region: '中国大陆',
    duration: '105分钟',
    director: '娄未',
    cast: '许清欢、秦慕、宋屿',
    tags: ['惊悚', '密室', '心理'],
    blurb: '新搬来的住户发现，这栋老楼没有十三号，但每到深夜，电梯总会停在一个不存在的楼层。',
  },
  {
    id: 9,
    title: '无声证人',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20crime%20thriller%20movie%20poster%2C%20silhouette%20at%20foggy%20window%20with%20blurred%20city%20lights%2C%20dark%20moody%20background%2C%20cool%20teal%20tones%20with%20amber%20accent%2C%20tense%20atmosphere%2C%20film%20grain&width=400&height=600&seq=sm-m9&orientation=portrait',
    year: 2024,
    rating: 8.0,
    genre: '悬疑',
    region: '中国大陆',
    duration: '119分钟',
    director: '严贺',
    cast: '孟川、罗映、程亦',
    tags: ['犯罪', '法庭', '反转'],
    blurb: '唯一的目击者是位听障画师，她用画笔记录下的十二幅速写，成了整起案件最沉默也最锋利的证词。',
  },
  {
    id: 10,
    title: '归途列车',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20drama%20movie%20poster%2C%20passenger%20looking%20out%20train%20window%20at%20dusk%20countryside%2C%20warm%20golden%20light%2C%20dark%20interior%20background%2C%20nostalgic%20mood%2C%20soft%20film%20grain%20texture&width=400&height=600&seq=sm-m10&orientation=portrait',
    year: 2024,
    rating: 8.7,
    genre: '剧情',
    region: '中国大陆',
    duration: '126分钟',
    director: '叶知秋',
    cast: '白岚、徐霍、姜月',
    tags: ['公路', '亲情', '治愈'],
    blurb: '一趟开了三十年的绿皮火车即将停运，父子二人决定用最后一程，把没说出口的话补完。',
  },
  {
    id: 11,
    title: '山海之间',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20emotional%20drama%20movie%20poster%2C%20person%20standing%20on%20mountain%20ridge%20above%20sea%20of%20clouds%20at%20sunrise%2C%20warm%20amber%20light%2C%20dark%20silhouette%20background%2C%20sweeping%20composition%2C%20film%20grain&width=400&height=600&seq=sm-m11&orientation=portrait',
    year: 2025,
    rating: 8.5,
    genre: '剧情',
    region: '中国大陆',
    duration: '134分钟',
    director: '叶知秋',
    cast: '孟川、许清欢、边然',
    tags: ['人生', '成长', '摄影'],
    blurb: '一位风光摄影师在失去挚友后，用镜头重走两人约定过的十二座山海，把遗憾一步步走成了告别。',
  },
  {
    id: 12,
    title: '父亲的果园',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20family%20drama%20movie%20poster%2C%20old%20farmer%20in%20orchard%20at%20golden%20hour%2C%20warm%20sunlight%20through%20leaves%2C%20dark%20green%20background%2C%20tender%20mood%2C%20soft%20film%20grain%20texture&width=400&height=600&seq=sm-m12&orientation=portrait',
    year: 2023,
    rating: 8.3,
    genre: '剧情',
    region: '中国大陆',
    duration: '108分钟',
    director: '温向晚',
    cast: '徐霍、姜月、宁静殊',
    tags: ['乡土', '亲情', '慢生活'],
    blurb: '女儿带着城市里的方案回到老家，想把父亲守了半辈子的果园改成果园，两代人的争执在四季里慢慢成熟。',
  },
  {
    id: 13,
    title: '云端小城',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20animated%20movie%20poster%2C%20whimsical%20floating%20town%20among%20soft%20clouds%2C%20warm%20amber%20and%20pink%20sky%2C%20painterly%20style%2C%20dreamy%20atmosphere%2C%20soft%20light%2C%20animated%20film%20key%20art&width=400&height=600&seq=sm-m13&orientation=portrait',
    year: 2025,
    rating: 9.0,
    genre: '动画',
    region: '中国大陆',
    duration: '98分钟',
    director: '鹿鸣',
    cast: '配音：小满、阿舟、灯灯',
    tags: ['治愈', '奇幻', '合家欢'],
    blurb: '一座会漂浮的小城每天清晨都要重新寻找落脚的地方，而负责掌舵的，是个从没离开过屋顶的小女孩。',
  },
  {
    id: 14,
    title: '森林奇缘',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20animated%20movie%20poster%2C%20magical%20glowing%20forest%20with%20tiny%20lanterns%2C%20friendly%20creature%20silhouette%2C%20warm%20amber%20and%20green%20tones%2C%20dark%20enchanted%20background%2C%20painterly%20animation%20key%20art&width=400&height=600&seq=sm-m14&orientation=portrait',
    year: 2024,
    rating: 8.4,
    genre: '动画',
    region: '中国大陆',
    duration: '94分钟',
    director: '鹿鸣',
    cast: '配音：团子、松果、小满',
    tags: ['冒险', '友情', '奇幻'],
    blurb: '当整片森林的光都熄灭了，一只从没被记进图鉴的小生物，决定靠一盏旧灯找回所有走散的影子。',
  },
  {
    id: 15,
    title: '星海旅人',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20animated%20space%20adventure%20movie%20poster%2C%20young%20traveler%20with%20small%20robot%20on%20alien%20dune%20under%20starry%20sky%2C%20warm%20amber%20glow%2C%20dark%20cosmic%20background%2C%20painterly%20animation%20key%20art&width=400&height=600&seq=sm-m15&orientation=portrait',
    year: 2025,
    rating: 8.8,
    genre: '动画',
    region: '中国大陆',
    duration: '102分钟',
    director: '柯远',
    cast: '配音：灯灯、阿舟、团子',
    tags: ['科幻', '成长', '太空'],
    blurb: '少年与一台快没电的小机器人，在荒漠星球上寻找回家的星图，却发现家一直就在彼此的旅程里。',
  },
  {
    id: 16,
    title: '办公室风云',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20comedy%20movie%20poster%2C%20stressed%20office%20worker%20among%20flying%20papers%20in%20modern%20office%2C%20warm%20indoor%20lighting%2C%20dark%20playful%20background%2C%20humorous%20mood%2C%20film%20grain%20texture&width=400&height=600&seq=sm-m16&orientation=portrait',
    year: 2024,
    rating: 7.5,
    genre: '喜剧',
    region: '中国大陆',
    duration: '106分钟',
    director: '温向晚',
    cast: '程亦、姜月、赵凛',
    tags: ['职场', '爆笑', '群像'],
    blurb: '一次全公司范围的通知失误，让最不起眼的小职员被误认成新来的总裁，谎言越滚越大，会议室变成了舞台。',
  },
  {
    id: 17,
    title: '幸运周末',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20feel-good%20comedy%20movie%20poster%2C%20group%20of%20friends%20laughing%20in%20small%20warm%20cafe%2C%20golden%20light%2C%20dark%20cozy%20background%2C%20lively%20mood%2C%20soft%20film%20grain%20texture&width=400&height=600&seq=sm-m17&orientation=portrait',
    year: 2025,
    rating: 7.7,
    genre: '喜剧',
    region: '中国大陆',
    duration: '100分钟',
    director: '麦朗',
    cast: '何晴、宋屿、裴野',
    tags: ['轻喜剧', '友情', '都市'],
    blurb: '四个合租的青年中了张即将过期的彩票，为兑奖在周末横穿全城，笑料不断，也把各自的心事摊开了。',
  },
  {
    id: 18,
    title: '夏日信笺',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20romance%20movie%20poster%2C%20two%20young%20people%20writing%20letters%20under%20summer%20sunlight%2C%20warm%20amber%20tones%2C%20dark%20soft%20background%2C%20tender%20nostalgic%20mood%2C%20film%20grain%20texture&width=400&height=600&seq=sm-m18&orientation=portrait',
    year: 2024,
    rating: 8.1,
    genre: '爱情',
    region: '中国大陆',
    duration: '110分钟',
    director: '路遥青',
    cast: '宁静殊、秦慕、江晚',
    tags: ['青春', '书信', '治愈'],
    blurb: '两个从未见过面的人，靠一整个夏天的信往来，把彼此写进了对方最糟糕也最明亮的那段日子。',
  },
  {
    id: 19,
    title: '拾光之城',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20romance%20movie%20poster%2C%20couple%20silhouette%20on%20old%20town%20rooftop%20at%20sunset%2C%20warm%20amber%20and%20orange%20glow%2C%20dark%20cityscape%20background%2C%20romantic%20mood%2C%20film%20grain%20texture&width=400&height=600&seq=sm-m19&orientation=portrait',
    year: 2025,
    rating: 7.9,
    genre: '爱情',
    region: '中国台湾',
    duration: '115分钟',
    director: '路遥青',
    cast: '江晚、唐宁、关屿',
    tags: ['都市爱情', '重逢', '胶片'],
    blurb: '一家即将歇业的老照相馆，把两位多年未见的旧友重新约在了同一卷胶片里。',
  },
  {
    id: 20,
    title: '黑金迷局',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20crime%20movie%20poster%2C%20man%20in%20suit%20standing%20in%20dark%20vault%20of%20gold%20bars%2C%20single%20overhead%20light%2C%20dark%20high%20contrast%20background%20with%20amber%20highlights%2C%20tense%20mood%2C%20film%20grain&width=400&height=600&seq=sm-m20&orientation=portrait',
    year: 2025,
    rating: 8.6,
    genre: '犯罪',
    region: '中国大陆',
    duration: '130分钟',
    director: '韩铮',
    cast: '赵凛、裴野、罗映',
    tags: ['金融犯罪', '高智商', '反转'],
    blurb: '一份足以撼动整座城市的地下账本，让金融精英与老刑警不得不在二十四小时里赌上各自的底线。',
  },
  {
    id: 21,
    title: '边城迷案',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20crime%20mystery%20movie%20poster%2C%20small%20border%20town%20at%20night%20with%20lone%20car%20lights%2C%20dark%20rainy%20background%2C%20cool%20teal%20tones%20with%20amber%20street%20lamps%2C%20moody%20atmosphere%2C%20film%20grain&width=400&height=600&seq=sm-m21&orientation=portrait',
    year: 2024,
    rating: 8.2,
    genre: '犯罪',
    region: '中国大陆',
    duration: '121分钟',
    director: '严贺',
    cast: '宋屿、边然、秦慕',
    tags: ['警匪', '边境', '人性'],
    blurb: '一桩看似普通的失踪案，牵出边城十年间被掩埋的旧账，而所有人都曾是那个沉默的旁观者。',
  },
  {
    id: 22,
    title: '极地救援',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20adventure%20movie%20poster%2C%20rescue%20team%20crossing%20frozen%20blizzard%20landscape%2C%20dramatic%20pale%20light%2C%20dark%20stormy%20background%2C%20epic%20survival%20mood%2C%20film%20grain%20texture&width=400&height=600&seq=sm-m22&orientation=portrait',
    year: 2025,
    rating: 8.3,
    genre: '动作',
    region: '中国大陆',
    duration: '127分钟',
    director: '韩铮',
    cast: '季泽、白岚、许清欢',
    tags: ['灾难', '求生', '团队'],
    blurb: '一场突如其来的极地风暴，把科考站与外界彻底隔断，一支临时拼凑的救援队要在零下四十度里抢回生命。',
  },
  {
    id: 23,
    title: '时空信使',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20poster%2C%20glowing%20time%20portal%20in%20abandoned%20laboratory%2C%20warm%20amber%20and%20cool%20teal%20light%2C%20dark%20background%2C%20mysterious%20mood%2C%20film%20grain%20texture&width=400&height=600&seq=sm-m23&orientation=portrait',
    year: 2024,
    rating: 8.0,
    genre: '科幻',
    region: '中国大陆',
    duration: '117分钟',
    director: '柯远',
    cast: '唐宁、宁静殊、孟川',
    tags: ['时间旅行', '情感', '软科幻'],
    blurb: '一名邮差发现自己投递的每一封信，都会寄到过去的某一天，而收信人正是多年后的自己。',
  },
  {
    id: 24,
    title: '龙之谷传说',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20fantasy%20animation%20movie%20poster%2C%20dragon%20soaring%20over%20ancient%20valley%2C%20warm%20amber%20sunset%20sky%2C%20dark%20dramatic%20clouds%20background%2C%20epic%20painterly%20key%20art%2C%20fantasy%20mood&width=400&height=600&seq=sm-m24&orientation=portrait',
    year: 2025,
    rating: 8.7,
    genre: '动画',
    region: '中国大陆',
    duration: '108分钟',
    director: '鹿鸣',
    cast: '配音：松果、灯灯、团子',
    tags: ['奇幻', '冒险', '热血'],
    blurb: '传说每一条龙的鳞片里都封存着一段被遗忘的历史，而最后一个牧龙少年，要用自己的名字为它们解封。',
  },
];

export const genreList: string[] = ['全部', '动作', '科幻', '悬疑', '剧情', '动画', '喜剧', '爱情', '犯罪'];

export const heroStats: { value: string; label: string }[] = [
  { value: '12,800+', label: '累计收录影片' },
  { value: '3,260', label: '高分口碑佳作' },
  { value: '每日更新', label: '新鲜片单推送' },
  { value: '9 大', label: '类型快速筛选' },
];

export const featuredIds: number[] = [4, 13, 1, 10, 24, 20];

export const latestIds: number[] = [24, 6, 17, 11, 22, 8, 23, 19];

export interface RankingEntry {
  movieId: number;
  score: string;
  trend: 'up' | 'down' | 'same';
}

export const weeklyRanking: RankingEntry[] = [
  { movieId: 4, score: '热映 9.6', trend: 'up' },
  { movieId: 20, score: '热映 9.2', trend: 'up' },
  { movieId: 1, score: '热映 8.9', trend: 'same' },
  { movieId: 13, score: '热映 8.8', trend: 'up' },
  { movieId: 24, score: '热映 8.6', trend: 'down' },
  { movieId: 22, score: '热映 8.4', trend: 'same' },
  { movieId: 6, score: '热映 8.2', trend: 'down' },
  { movieId: 18, score: '热映 8.0', trend: 'same' },
  { movieId: 17, score: '热映 7.8', trend: 'up' },
  { movieId: 16, score: '热映 7.5', trend: 'same' },
];

export const topRatedRanking: RankingEntry[] = [
  { movieId: 13, score: '评分 9.0', trend: 'same' },
  { movieId: 4, score: '评分 8.9', trend: 'up' },
  { movieId: 15, score: '评分 8.8', trend: 'same' },
  { movieId: 10, score: '评分 8.7', trend: 'up' },
  { movieId: 24, score: '评分 8.7', trend: 'same' },
  { movieId: 1, score: '评分 8.6', trend: 'down' },
  { movieId: 20, score: '评分 8.6', trend: 'up' },
  { movieId: 11, score: '评分 8.5', trend: 'same' },
  { movieId: 7, score: '评分 8.4', trend: 'same' },
  { movieId: 14, score: '评分 8.4', trend: 'down' },
];

export const risingRanking: RankingEntry[] = [
  { movieId: 6, score: '涨幅 +42%', trend: 'up' },
  { movieId: 23, score: '涨幅 +37%', trend: 'up' },
  { movieId: 17, score: '涨幅 +31%', trend: 'up' },
  { movieId: 19, score: '涨幅 +28%', trend: 'up' },
  { movieId: 22, score: '涨幅 +24%', trend: 'up' },
  { movieId: 8, score: '涨幅 +19%', trend: 'up' },
  { movieId: 9, score: '涨幅 +15%', trend: 'down' },
  { movieId: 21, score: '涨幅 +11%', trend: 'same' },
  { movieId: 5, score: '涨幅 +8%', trend: 'down' },
  { movieId: 12, score: '涨幅 +5%', trend: 'same' },
];

export interface EditorPick {
  movieId: number;
  headline: string;
  reason: string;
}

export const editorPicks: EditorPick[] = [
  {
    movieId: 10,
    headline: '《归途列车》：把告别拍成一场缓慢的抵达',
    reason: '没有激烈的冲突，只有车厢里的沉默与窗外倒退的风景。它适合在深夜一个人慢慢看完，然后给很久没联系的人发一条消息。',
  },
  {
    movieId: 13,
    headline: '《云端小城》：今年最不该错过的合家欢动画',
    reason: '画风温柔、节奏轻快，孩子看到冒险，大人看到守护。它证明了国产动画完全可以兼顾想象力与情感浓度。',
  },
  {
    movieId: 4,
    headline: '《星际回响》：硬科幻外壳下的一封家书',
    reason: '视觉奇观之外，真正打动人的是那些关于孤独与牵挂的细节。适合喜欢在宏大叙事里找微小共鸣的观众。',
  },
  {
    movieId: 20,
    headline: '《黑金迷局》：全程无尿点的金融悬疑',
    reason: '剧本层层反转却不故弄玄虚，每个细节都在后面兑现。想找一部让人一口气刷完又不失智商的片子，选它。',
  },
];

export interface GuideCard {
  icon: string;
  title: string;
  desc: string;
  tips: string[];
}

export const guideCards: GuideCard[] = [
  {
    icon: 'ri-compass-3-line',
    title: '三步锁定想看的电影',
    desc: '从时间、类型到心情，用最少的步骤缩小范围。',
    tips: ['先按当下可支配的时间挑时长', '再用类型标签筛掉不想看的题材', '最后看评分与简介是否对上心情'],
  },
  {
    icon: 'ri-bar-chart-2-line',
    title: '三分钟看懂排行榜',
    desc: '不同榜单反映的其实是完全不同的观影需求。',
    tips: ['热映榜看的是当下讨论度', '高分榜更适合挑选沉淀下来的佳作', '飙升榜帮你提前发现被低估的新片'],
  },
  {
    icon: 'ri-shield-star-line',
    title: '挑高分片的实用技巧',
    desc: '评分高不等于适合你，关键是把评分和标签一起看。',
    tips: ['优先看与你口味接近的类型标签', '留意"反转""群像""慢节奏"等关键词', '评分之外，简介的第一句往往最能定调'],
  },
  {
    icon: 'ri-group-line',
    title: '家庭与聚会的选片思路',
    desc: '和不同的人一起看，选片逻辑完全不同。',
    tips: ['多人聚会优先合家欢与轻喜剧', '情侣向可选爱情或治愈剧情', '长辈在场尽量避开高强度的惊悚题材'],
  },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqList: FaqItem[] = [
  {
    q: '神马电影这个页面主要提供什么内容？',
    a: '这是一个集推荐、榜单与分类筛选于一体的选片导航页。你可以在同一个页面里看到今日精选、不同维度的排行榜、最新大片、按类型划分的影片库，以及选片指南与常见问题，不用来回跳转就能快速定位想看的内容。',
  },
  {
    q: '榜单里"热映榜""高分榜""飙升榜"有什么区别？',
    a: '热映榜看的是近期的讨论热度，适合想知道大家在追什么的时候参考；高分榜更侧重长期沉淀下来的口碑，适合挑耐看的佳作；飙升榜则关注涨幅最快的新片，适合想抢先发现被低估作品的人。你可以按自己的需求切换查看。',
  },
  {
    q: '怎么用分类筛选快速找到合适的一部？',
    a: '进入"分类找片"区域，先点选你感兴趣的类型标签，再在搜索框里输入片名、标签或主演名做二次筛选。列表会实时更新并显示当前匹配到的影片数量，如果结果太少，清空搜索或切回"全部"即可恢复完整片库。',
  },
  {
    q: '页面上的评分和推荐理由是怎么呈现的？',
    a: '每部影片都带有评分、年份、类型、时长、导演与主创等基础信息，帮助你在点开之前先做判断。"编辑推荐"板块则会额外给出一段具体的推荐理由，说明它适合什么样的观众、什么场景观看，方便你快速对号入座。',
  },
  {
    q: '这些片单会更新吗？',
    a: '页面中"最新大片"与各类榜单定位为持续更新的内容区，日常会有新的影片被补充进来。如果你希望某类题材或某个榜单被重点呈现，可以把它作为后续调整的方向。',
  },
  {
    q: '在手机上浏览体验如何？',
    a: '整个页面采用响应式布局，卡片、榜单与筛选控件在手机上会自动改为更适合单手浏览的排布，纵向滚动即可阅读完整内容，标签与搜索框也都支持触屏与键盘操作。',
  },
];